import * as React from "react";
import { FirmInstruction } from "../../../../../../../Wrap/Models/Models/Company/FirmInstruction";
import { DefaultSetting } from "./DefaultSetting";
import { SectionHeader } from "../../../../../../Dashboard/Components/Clients/NewBusinessWizard/Components/SharedComponents";
import { CustomSetting } from "./CustomSetting";
import { BackOffice } from "./BackOffice";
import { BankDetail } from "./BankDetail";
import { BankAccountOwner } from "../../../../../../../Wrap/Constants/Enums/Domain/BankAccountOwner";
import { EdiMailBox } from "../../../../../../../Wrap/Models/Models/Company/EdiMailBox";
import { CompanyWizardAction } from "../../../Actions/CompanyWizardAction";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { DisinvestmentStrategyType } from "../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { DisinvestmentStrategySection } from "./DisinvestmentStrategySection";
import { MultiPropositionType } from "../../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";

interface ICommissionProps extends IProcessComponentProps {
    isReview?: boolean;
    data: FirmInstruction;
    isNetWork: boolean;
    onChange: (changes) => void;
    onRef: (ref) => void;
    bankOwnerType: BankAccountOwner;
}

interface ICommissionState {
    ediOptions: EdiMailBox[];
    errorMessages: string[];
}

export class Commission extends ProcessComponent<ICommissionProps, ICommissionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            ediOptions: [],
            errorMessages: [],
        };
    }

    componentDidMount() {
        super.componentDidMount();
        CompanyWizardAction.getEdiMailBoxIds((data) => {
            this.setState({ ediOptions: data });
        });
    }

    isValid(): boolean {
        return super.isValid();
    }

    render() {
        const { data, isNetWork } = this.props;
        const isfondzone = (data?.MultiProposition ?? []).every((ele) => ele == MultiPropositionType.Fundzone);
        return (
            <>
                {this.state.errorMessages.map((message) => (
                    <Alert message={message} alertType={AlertType.Error}></Alert>
                ))}
                <h2>Remuneration and valuation</h2>
                {data.UseDefaultCommissionOption && <DefaultSetting data={data} onChange={() => {}} onRef={() => {}} />}
                <hr />
                <div className="row">
                    <div className="col-xs-12 col-sm-7">
                        <CustomSetting
                            isReview={this.props.isReview}
                            data={data}
                            onChange={(v) => this.props.onChange(v)}
                            onRef={(ref) => this.appendChild(ref)}
                            ediOptions={this.state.ediOptions}
                            isNetWork={isNetWork}
                        />
                    </div>
                </div>
                <hr />
                {!isNetWork && !isfondzone && (
                    <>
                        {SectionHeader("Disinvestment strategy")}
                        <DisinvestmentStrategySection
                            data={data}
                            onChange={(changes) => this.props.onChange(changes)}
                            onRef={(ref) => this.appendChild(ref)}
                            isReview={this.props.isReview}
                            checkBoxOption={[
                                DisinvestmentStrategyType.Proportional,
                                DisinvestmentStrategyType.Lifo,
                                DisinvestmentStrategyType.LVS,
                            ]}
                        />
                        <hr />
                    </>
                )}

                <BackOffice
                    data={this.props.data.BackOfficeProviderSettings}
                    acornCommissionSettings={this.props.data.AcornCommissionSettings}
                    onChange={(data) => this.props.onChange({ BackOfficeProviderSettings: data })}
                    onRef={(ref) => this.appendChild(ref)}
                    isReview={this.props.isReview}
                />
                <hr />
                <BankDetail
                    data={data}
                    onChange={(v) => this.props.onChange(v)}
                    isReview={this.props.isReview}
                    onRef={(ref) => this.appendChild(ref)}
                    owner={this.props.bankOwnerType}
                />
            </>
        );
    }
}
